import axios from "axios";
import authClient from "app/auth/Auth";
import { getEnvironmentVariable } from "v2/infrastructure/common/types/EnvironmentVariables";
import interceptors from "./interceptors";

export const apiClient = () => {
  const axiosInstance = axios.create({
    baseURL: getEnvironmentVariable("API"),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authClient.getAccessToken()}`,
    },
  });

  interceptors(axiosInstance);

  return {
    post: <T>(path, body) => axiosInstance.post<T>(path, body),
    put: <T>(path, body) => axiosInstance.put<T>(path, body),
    get: <T>(path, options) => axiosInstance.get<T>(path, options),
    delete: <T>(path, body) => axiosInstance.delete<T>(path, { data: body }),
  };
};

export const apiInstance = apiClient();
